// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconBookmarkCheckmark = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M10.879 11.581L16 6.579v2.795l-5.164 5.044L8 11.478V8.595z" />,
    <path
      fillRule="evenodd"
      d="M20 1H4v20l1.516.856L12 17.946l6.483 3.91L20 21zM6 19.229V3h12v16.229l-5.483-3.307h-1.033z"
    />
  );
export default SvgIconBookmarkCheckmark;
